import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import { Globe } from "lucide-react";

// CSS
import "./Ourteam.css";

// Banner & Assets
import ourteambanner from "../img/team/our-team-banner.jpg";
// Note: Images are imported once and reused
import sanjay from "../img/team/sanjay-gupta.jpg";
import kanchan from "../img/team/kanchan-gupta.jpg";
import utsav from "../img/team/utsav-gupta.jpg";
import chhavi from "../img/team/chhavi-gupta.jpg";
import mayank from "../img/team/mayank.jpg";
import puneet from "../img/team/puneet.jpg";
import sanjaybisht from "../img/team/sanjay-bisht.jpg";
import karan from "../img/team/karan-jamwal.jpg";
import rizwan from "../img/team/rizwan.jpg";
import rosy from "../img/team/rosy.jpg";
import akashdeep from "../img/team/akashdeep-sharma.jpg";
import deepak from "../img/team/deepak-kumar.jpg";
import sandeep from "../img/team/sandeep.jpg";
import charanjeet from "../img/team/charanjeet-singh.jpg";
import vinay from "../img/team/vinay-gaur.jpg";
import kapil from "../img/team/kapil-dhawan.png";
import akash from "../img/team/akash-tiwari.jpg";
import ramankwatra from "../img/team/raman-kwatra.jpg";
import narindra from "../img/team/narindra-dhiman.jpg";
import devesh from "../img/team/devesh.jpg";
import sanjiv from "../img/team/sanjiv-gupta.jpg";
import dimple from "../img/team/dimple-bansal.jpg";
import guman from "../img/team/guman-singh.jpg";
import amanpreet from "../img/team/amanpreet-kaur.jpg";
import harinder from "../img/team/harinder-singh.jpg";
import anurag from "../img/team/anurag-tiwari.jpg";
import Gurpreet from "../img/team/gurpreet-singh.jpg";
import tapas from "../img/team/tapas.png";
import amrit from "../img/team/amrit-sagar.jpg";
import vishal from "../img/team/vishal.jpg";
import sanjaykaushik from "../img/team/sanjay-kaushik.jpg";
import sarabjeet from "../img/team/sarabjeet-kaur.jpg";
import sujeet from "../img/team/sujeet-kumar.jpg";
import Shailendra from "../img/team/shail.jpeg";
import Antima from "../img/team/antima.jpeg";
import sapna from "../img/team/sapna.jpeg";
import manish from "../img/team/manish-kumar.jpg";
import sunit from "../img/team/sunit.jpg";
import sahvan from "../img/team/mohd-sahvan.jpg";
import yusuf from "../img/team/yusuf-khan.jpg";
import waseem from "../img/team/waseem-khan.jpg";
import vikas from "../img/team/vikas-kumar.jpg";
import arun from "../img/team/arun.jpg";
import parvinder from "../img/team/parvinder-singh.jpg";
import rohit from "../img/team/rohit-sharma.jpg";
import jagmohan from "../img/team/jagmohan-singh.jpg";

// TEAM DATA
const teamData = [
   {
      category: "Founders & Board Members",
      members: [
         { name: "Sanjay Gupta", role: "Founder & Managing Director", photo: sanjay, bio: "Sanjay Gupta is a chartered accountant and Company Secretary with 35+ years of experience across finance, taxation, logistics, and administration. He co-promoted Spray Engineering Ltd. before founding Spinoff." },
         { name: "Kanchan Gupta", role: "Founder & Director", photo: kanchan, bio: "Kanchan Gupta oversees administrative decisions and new business strategies. She manages retail operations and fund flows, while focusing on staff welfare and motivation." },
         { name: "Chhavi Gupta", role: "Director", photo: chhavi, bio: "Chhavi Gupta manages factory administration and corporate operations. She is an expert in customer support services and internal business management." },
         { name: "Utsav Gupta", role: "Director", photo: utsav, bio: "Utsav Gupta manages factory operations including production, design, quality, procurement, and social media. He brings extensive management expertise to the team." },
         { name: "Mayank Deva", role: "VP- Business Development", photo: mayank, bio: "Mayank brings 25+ years of leadership from telecom giants like Airtel and Tata. He leads SCM, sourcing, and commercial contracting at Spinoff." }
      ]
   },
   {
      category: "Technical Leadership",
      members: [
         { name: "Puneet Wadhawan", role: "CTO", photo: puneet, bio: "A brilliant electronics engineer and founder member of the technical group. He heads R&D, SMT floors, PCB design, and currently leads the Lithium Battery Project in Rajpura." },
         { name: "Sanjay Bisht", role: "Head Rajpura (Mechanical)", photo: sanjaybisht, bio: "A mechanical engineer with 12+ years of experience. He manages the Rajpura factory campus, specializing in CNC machines and electromechanical systems." },
         { name: "Karan Jamwal", role: "Production Incharge", photo: karan, bio: "Karan manages the entire LED lighting production process, ensuring high-quality and efficient manufacturing for the division." }
      ]
   },
   {
      category: "R&D Engineers",
      members: [
         { name: "Rizwan", role: "R&D Engineer", photo: rizwan, bio: "Expert in product research, schematic design, and programming across Arduino, ESP32, and MATLAB for advanced electronics." },
         { name: "Rosy", role: "R&D Engineer", photo: rosy, bio: "Specializes in PCB design, product testing, and validation of LED lighting solutions." },
         { name: "Akashdeep Sharma", role: "Program Manager", photo: akashdeep, bio: "9+ years of experience in complex project management, resource allocation, and risk mitigation." },
         { name: "Deepak Kumar", role: "R&D Engineer", photo: deepak, bio: "Specializes in IoT solutions, circuit design, and microcontroller programming for next-gen electronics." }
      ]
   },
   {
      category: "Production & Design",
      members: [
         { name: "Charanjeet Singh", role: "Electrical Engineer", photo: charanjeet, bio: "5+ years managing production floors and CNC machine operations with team leadership skills." },
         { name: "Sandeep", role: "Service Engineer", photo: sandeep, bio: "9 years of expertise in LED light repair, maintenance, and technical diagnostics." },
         { name: "Vinay Gaur", role: "Design Engineer", photo: vinay, bio: "8 years specializing in rubber mold design for the automotive industry." },
         { name: "Kapil Dhawan", role: "Design Engineer", photo: kapil, bio: "18+ years in Design & Development (NX11/UG), VMC machining, and lean manufacturing." },
         { name: "Akash Tiwari", role: "Design Engineer", photo: akash, bio: "6+ years in mold design, tool room management, and process planning." }
      ]
   },
   {
      category: "Sales & Business Development",
      members: [
         { name: "Raman Kwatra", role: "Head Corporate Sales", photo: ramankwatra, bio: "17+ years of experience in pharma lighting sales and corporate development." },
         { name: "Narindra Dhiman", role: "Corporate Sales", photo: narindra, bio: "15 years of CRM, procurement, and retail accounting expertise." },
         { name: "Devesh", role: "Sales Manager", photo: devesh, bio: "MBA with 8 years of hardware industry sales and market growth operations." },
         { name: "Sanjiv Gupta", role: "Corporate Sales", photo: sanjiv, bio: "20+ years in industrial lighting, hardware, and sheet metal sectors." },
         { name: "Dimple Bansal", role: "Store In-Charge", photo: dimple, bio: "Specializes in inventory control, store operations, and client satisfaction." },
         { name: "Guman Singh", role: "Senior Sales Executive", photo: guman, bio: "14 years of hardware industry sales and relationship management." },
         { name: "Amanpreet Kaur", role: "Sales Consultant", photo: amanpreet, bio: "3 years in residential and commercial lighting project consultancy." }
      ]
   },
   {
      category: "IT & Digital Team",
      members: [
         { name: "Harinder Singh", role: "Team Leader IT", photo: harinder, bio: "Since 2012, manages group data flow, servers, and multi-locational IT support." },
         { name: "Anurag Tiwari", role: "Software Team Lead", photo: anurag, bio: "4+ years in software development delivering dedicated and innovative tech solutions." },
         { name: "Gurpreet Singh", role: "IT Engineer", photo: Gurpreet, bio: "Expert in hardware, software networking, and technology transformation." },
         { name: "Tapas Kumar Dutta", role: "Social Media Manager", photo: tapas, bio: "7+ years in digital marketing, content creation, and brand growth strategy." },
         { name: "Amrit Sagar", role: "Graphic Designer", photo: amrit, bio: "Specializes in visually compelling brand identity and digital assets." },
         { name: "Vishal Kumar", role: "Graphic Designer", photo: vishal, bio: "Passionate designer focused on innovative visual storytelling and brand identity." }
      ]
   },
   {
      category: "Accounts & Finance",
      members: [
         { name: "Sanjay Kaushik", role: "CFO", photo: sanjaykaushik, bio: "MBA Finance with 20+ years in audit, financial analysis, and regulatory compliance." },
         { name: "Sarabjeet Kaur", role: "Accounts Member", photo: sarabjeet, bio: "6 years in budgeting, financial reporting, and accurate data reconciliation." },
         { name: "Sujeet Kumar", role: "Account Executive", photo: sujeet, bio: "Expert in Tally Prime, GST, TDS, and bank reconciliations." },
         { name: "Shailendra", role: "Account Executive", photo: Shailendra, bio: "5 years in Precise financial operations, Tally, and GST management." },
         { name: "Antima", role: "Account Executive", photo: Antima, bio: "4 years in accurate financial data entry and reconciliation operations." }
      ]
   },
   {
      category: "HR & Operations",
      members: [
         { name: "Sapna Bhatia", role: "HR Manager", photo: sapna, bio: "3+ years in Talent Acquisition across IT and manufacturing sectors PAN India." },
         { name: "Manish Kumar", role: "HR Manager (Payroll)", photo: manish, bio: "7 years in employee relations, payroll processing, and audit support." },
         { name: "Sunit Kumar", role: "Procurement Head", photo: sunit, bio: "6 years managing LED lighting supplier relationships and contract negotiations." },
         { name: "Mohd Sahvan", role: "Procurement Head", photo: sahvan, bio: "9+ years in Lithium Battery sourcing and vendor performance evaluation." },
         { name: "Yusuf Khan", role: "Store Head (Rajpura)", photo: yusuf, bio: "15 years of store management and inventory control expertise." },
         { name: "Waseem Khan", role: "Store Head (Mohali)", photo: waseem, bio: "8 years in store logistics and process optimization." },
         { name: "Vikas Kumar", role: "Store In-Charge", photo: vikas, bio: "5 years dedicated to efficient store operations and success." },
         { name: "Arun Kumar", role: "Architect", photo: arun, bio: "7+ years delivering sustainable architecture and interior design projects." }
      ]
   },
   {
      category: "Support & Maintenance",
      members: [
         { name: "Parvinder Singh", role: "HOD Maintenance", photo: parvinder, bio: "18 years specializing in electrical systems, networking, and technical security." },
         { name: "Rohit Sharma", role: "TL After Sales", photo: rohit, bio: "10 years in electronics installation, troubleshooting, and connectivity." },
         { name: "Jagmohan Singh", role: "Team Member", photo: jagmohan, bio: "12 years expertise in electrical systems and technical field operations." }
      ]
   }
];

// REUSABLE TEAM CARD
const TeamMember = ({ member }) => (
   <div className="team-card">
      <div className="team-img-wrap">
         <img src={member.photo} alt={member.name} loading="lazy" />
      </div>
      <div className="team-info">
         <span className="role">{member.role}</span>
         <h4>{member.name}</h4>
         <p>{member.bio}</p>
      </div>
   </div>
);

function Ourteam() {
   const [isVisible, setIsVisible] = useState(false);

   useEffect(() => {
      setIsVisible(true);
      window.scrollTo({ top: 0, behavior: 'smooth' });
   }, []);

   return (
      <div className={`team-container ${isVisible ? "is-ready" : ""}`}>
         <Helmet>
            <title>Our Team | Spinoff Technopark Ltd - Experts in Innovation</title>
            <meta name="description" content="Meet our multi-disciplinary team of dedicated professionals driving excellence in LED, Lithium Energy, and R&D." />
         </Helmet>

         {/* TEAM HERO - MIRROR OF INFRA */}
         <section className="team-hero">
            <div className="team-hero-inner">
               <div className="year-badge" style={{ background: 'rgba(255,255,255,0.05)', color: '#6366f1' }}>
                  <Globe size={14} style={{ marginRight: '8px', verticalAlign: 'middle' }} />
                  OUR WORLD-CLASS TALENT
               </div>
               <h1 style={{fontSize:'55px'}}>Driving The <span className="highlight-gradient">Human Edge.</span></h1>
               <p>
                  United by a shared passion for excellence, our team of 200+ dedicated
                  professionals delivers exceptional quality and groundbreaking innovation.
               </p>
            </div>
         </section>

         {/* TEAM SECTIONS */}
         {teamData.map((section, idx) => (
            <section key={idx} className="team-section">
               <div className="max-w">
                  <div className="section-title-wrap">
                     <h2>{section.category}</h2>
                  </div>
                  <div className={`team-grid ${section.category === 'Founders & Board Members' ? 'founders-grid' : ''}`}>
                     {section.members.map((member, mIdx) => (
                        <TeamMember key={mIdx} member={member} />
                     ))}
                  </div>
               </div>
            </section>
         ))}

      </div>
   );
}

export default Ourteam;
